<template>

<div class="support-tickets-detail">
    <div class="support-ticket-controls">
        <button class="button action" @click="$router.push(returnPath)">Back to List</button>
        <h3 v-if="support_ticket_id != 'new'" style="text-align: center;"><span v-if="getAdministratorFlag">{{ clientDisplayName }} &rang; </span>{{ supportTicketDetail.topic }}</h3>
        <div class="two-columns" v-if="support_ticket_id != 'new'" >
            <router-link :to="previousTicket" :class="previousTicket ? 'previous' : 'disabled'"><i class="fas fa-angle-left"></i>&nbsp;Prev</router-link>
            <router-link :to="nextTicket" :class="nextTicket ? 'next' : 'disabled'">Next&nbsp;<i class="fas fa-angle-right"></i></router-link>
        </div>
    </div>
    <div :class="getAdministratorFlag ? 'detail-admin' : 'detail'">
        <div>
            <div class="meta">
                <ul class="support-ticket-detail">
                    <li v-if="support_ticket_id != 'new'"><label>Ticket ID:</label> {{ supportTicketDetail.support_ticket_id }}</li>
                    <li v-if="support_ticket_id != 'new'"><label>Created at:</label> {{ $moment(supportTicketDetail.support_ticket_time).format('M/D/YY - h:mm a') }}</li>
                    <li v-if="support_ticket_id != 'new' && supportTicketThread.length > 0"><label>Last reply:</label> {{ $moment(supportTicketThread[0].support_ticket_detail_time).format('M/D/YY - h:mm a') }}</li>
                    <li v-if="support_ticket_id == 'new' && getAdministratorFlag">
                        <label-required label="Dealer: " :condition="newSupportTicketDetail.client_id"></label-required>
                        <select v-model="newSupportTicketDetail.client_id">
                            <option value=''>Select...</option>
                            <option v-for="(client, index) in clients" :value="client.client_id" :key="'client_id-' + index">{{ client.company_name }} [{{ client.client_id }}]</option>
                        </select>
                    </li>
                    <li v-if="support_ticket_id == 'new'">
                        <label-required label="Subject: " :condition="newSupportTicketDetail.topic"></label-required>
                        <input type="text" v-model="newSupportTicketDetail.topic" placeholder="What's this ticket about?">
                    </li>
                    <li>
                        <label-required label="Urgency: " :condition="newSupportTicketDetail.support_ticket_priority_id || supportTicketDetail.support_ticket_priority_code"></label-required>
                        <select v-if="support_ticket_id == 'new'" v-model="newSupportTicketDetail.support_ticket_priority_id">
                            <option value=''>Select...</option>
                            <option v-for="(priorityCode, index) in supportTicketPriorityCodes" :value="priorityCode.support_ticket_priority_id" :key="'urgency-' + index">{{ priorityCode.support_ticket_priority_code }}</option>
                        </select>
                        <select v-else-if="getAdministratorFlag" v-model="supportTicketDetail.support_ticket_priority_id">
                            <option value=''>Select...</option>
                            <option v-for="(priorityCode, index) in supportTicketPriorityCodes" :value="priorityCode.support_ticket_priority_id" :key="'urgency-' + index">{{ priorityCode.support_ticket_priority_code }}</option>
                        </select>
                        <span v-else>{{ supportTicketDetail.support_ticket_priority_code }}</span>
                    </li>
                    <li v-if="support_ticket_id != 'new'">
                        <label>Status: </label>
                        <select v-if="getAdministratorFlag" v-model="supportTicketDetail.support_ticket_status_id">
                            <option value=''>Select...</option>
                            <option v-for="(statusCode, index) in supportTicketStatusCodes" :value="parseInt(statusCode.support_ticket_status_id)" :key="'status-' + index">{{ statusCode.support_ticket_status_code }}</option>
                        </select>
                        <span v-else>{{ supportTicketDetail.support_ticket_status_code }}</span>
                    </li>
                    <li v-if="support_ticket_id != 'new' && getAdministratorFlag">
                        <label>Tag:&nbsp;</label>
                        <select v-model="supportTicketDetail.support_ticket_tag_id">
                            <option value=''>Select...</option>
                            <option v-for="(tag, index) in supportTicketTags" :value="parseInt(tag.support_ticket_tag_id)" :key="'tag-' + index">{{ tag.description }}</option>
                        </select>
                    </li>
                    <div v-if="getAdministratorFlag" class="button grey" @click="updateTicket()">Update Ticket</div>
                    <div v-if="!getAdministratorFlag && support_ticket_id != 'new' && supportTicketDetail.support_ticket_status_code == 'CLOSED'" class="button grey" @click="reopenSupportTicket()">Reopen Ticket</div>
                    <div v-if="!getAdministratorFlag && support_ticket_id != 'new' && supportTicketDetail.support_ticket_status_code != 'CLOSED'" class="button grey" @click="closeSupportTicket()">Close Ticket</div>
                    <div v-if="savingTicket" class="loading"><i class="fas fa-spinner fa-spin"></i></div>
                </ul>
                <ul v-if="support_ticket_id != 'new' && getAdministratorFlag" class="client-info">
                    <li>
                        <strong>{{ clientDisplayName }}</strong>
                        <div><label>Client ID:&nbsp;</label>{{ supportTicketDetail.client_id }}</div>
                        <div><label>Client Type:&nbsp;</label>{{ supportTicketDetail.client_type }}</div>
                        <div><label>Start Date:&nbsp;</label>{{ supportTicketDetail.start_date }}</div>
                        <div><label>Processor:&nbsp;</label>{{ supportTicketDetail.payment_processor }}</div>
                    </li>
                    <li>
                        <a :href="'http://' + supportTicketDetail.domain_name" target="_blank">{{ supportTicketDetail.domain_name }}</a>
                    </li>
                    <li>
                        <a :href="'mailto:' + supportTicketDetail.email_address">{{ supportTicketDetail.email_address }}</a>
                    </li>
                    <li>{{ supportTicketDetail.phone_number }}</li>
                    <li><a class="button grey" :href="'/dashboard/legacy/clientmaintenance.php?url_page=show&primary_id=' + supportTicketDetail.client_id" target="_blank">Manage Client</a></li>
                    <li><a class="button grey" :href="logInAsLink" target="_blank">Log in as dealer</a></li>
                    <li>
                        <div class="input-with-control" style="font-size: 0.9em; margin: 2em 0 0 0;">
                            <input type="text" v-model="searchUPC" placeholder="Search UPC..." @keyup.enter="searchForUPC()">
                            <div class="button action input-go" @click="searchForUPC()"><i class="fas fa-search"></i></div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div>
            <label-required v-if="support_ticket_id != 'new'" label="Enter a reply to this ticket..." :condition="newSupportTicketDetail.content"></label-required>
            <label-required v-else-if="support_ticket_id == 'new' && getAdministratorFlag" label="First comment for this new ticket..." :condition="newSupportTicketDetail.content"></label-required>
            <label-required v-else label="Describe your issue or question and please be as specific as possible..." :condition="newSupportTicketDetail.content"></label-required>
            <div class="new-message">
                <textarea class="content" cols="30" rows="10" v-model="newSupportTicketDetail.content" ref="support_ticket_content"></textarea>
                <div class="content-controls two-columns">
                    <div class="add-link" v-if="getAdministratorFlag">
                        <input type="text" placeholder="Article Link #" v-model="articleLinkId" @keyup.enter="addLinkToDetail">
                    </div>
                    <div class="attach-files-toggle" @click="showDropzone = !showDropzone">
                        <i class="fas fa-caret-right" :class="{ 'fa-rotate-90': showDropzone }"></i>
                        Need to attach a screenshot or file?
                    </div>
                    <div :class="['button', canBeSaved ? 'action' : 'disabled']" @click="saveDetail('ticket')">Send</div>
                    <div v-if="message"></div>
                    <div v-if="message" class="message">{{ message }}</div>
                    <div class="attach-files" :class="{ show: showDropzone }" :style="'height: ' + attachFilesHeight">
                        <vue-dropzone @vdropzone-file-added="supportFilesFileAdded" @vdropzone-success-multiple="supportFilesUploadSuccess" @vdropzone-error="supportFilesUploadError" @vdropzone-removed-file="supportFilesRemovedFile" ref="supportFilesDropzone" id="site_background_dropzone" :options="supportFilesDropzoneOptions"></vue-dropzone>
                        <div class="uploaded-files dz-preview dz-file-preview"></div>
                    </div>
                </div>
                <loading v-if="savingDetail"></loading>
            </div>

            <ul class="support-ticket-thread">
                <li :class="[ threadItem.user_type_code.toLowerCase() ]" v-for="(threadItem, index) in supportTicketThread" :key="'thread-item-' + threadItem.support_ticket_detail_id">
                    <div v-if="threadItem.user_type_code.indexOf('ADMIN') > -1" class="display-icon">
                        <i class="fas fa-user-astronaut"></i>
                        <div>{{ threadItem.first_name }} {{ threadItem.last_name }} at CDS</div>
                    </div>
                    <div v-else class="display-icon">
                        <i class="far fa-user"></i>
                        <div>{{ threadItem.user_name }}<br>{{ threadItem.user_type_code }}</div>
                    </div>

                    <div class="content">
                        <div class="user" v-if="threadItem.user_type_code.indexOf('ADMIN') > -1">
                            {{ threadItem.first_name }} {{ threadItem.last_name }} - CDS &rang; {{ $moment(threadItem.support_ticket_detail_time).format('M/D/YY - h:mm a')}}
                        </div>
                        <div class="user" v-else>
                            {{ threadItem.first_name ? threadItem.first_name + ' ' + threadItem.last_name : threadItem.user_name }} &rang; {{ $moment(threadItem.support_ticket_detail_time).format('M/D/YY - h:mm a')}}
                        </div>
                        <p v-linkify v-html="threadItem.content"></p>
                        <div class="attachments" v-if="threadItem.support_files.length > 0">
                            <strong>Attachments</strong>
                            <a v-for="(attachment, index) in threadItem.support_files" :href="attachment.url" target="_blank">
                                <img :src="attachment.url" :alt="attachment.name" v-if="attachment.type == 'image'">
                                <span v-else>{{ attachment.name }}</span>
                            </a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div v-if="getAdministratorFlag">
            <label>Add an internal note...</label>
            <div class="new-note">
                <textarea name="" id="" v-model="newSupportTicketNote.content"></textarea>
                <div class="attach-files-toggle" @click="showDropzoneNote = !showDropzoneNote">
                    <i class="fas fa-caret-right" :class="{ 'fa-rotate-90': showDropzoneNote }"></i>
                    Attach a file
                </div>
                <div class="attach-files" :class="{ show: showDropzoneNote }">
                    <vue-dropzone @vdropzone-file-added="adminFilesFileAdded" @vdropzone-success-multiple="adminFilesUploadSuccess" @vdropzone-error="adminFilesUploadError" @vdropzone-removed-file="adminFilesRemovedFile" ref="adminFilesDropzone" id="site_background_dropzone" :options="adminFilesDropzoneOptions"></vue-dropzone>
                    <div class="uploaded-admin-files dz-preview dz-file-preview"></div>
                </div>
                <div :class="['button', newSupportTicketNote.content ? 'action' : 'disabled']" @click="saveDetail('note')">Add Note{{  newSupportTicketNote.file_reference.length > 0 ? ' and File' : '' }}</div>
            </div>
            <ul class="support-ticket-notes" v-if="supportTicketNotes.length > 0">
                <li :class="[ noteItem.user_type_code.toLowerCase() ]" v-for="noteItem in supportTicketNotes" :key="'thread-item-' + noteItem.support_ticket_detail_id">
                    <div class="user">{{ noteItem.first_name }} &rang; {{ $moment(noteItem.support_ticket_detail_time).format('M/D/YY - h:mm a')}}</div>
                    <p v-linkify v-html="noteItem.content"></p>
                    <div class="attachments" v-if="noteItem.support_files && noteItem.support_files.length > 0">
                        <a v-for="(attachment, index) in noteItem.support_files" :href="attachment.url" target="_blank" :key="'support-note-file-' + index">
                            <img :src="attachment.url" :alt="attachment.name" v-if="attachment.type == 'image'">
                            <span v-else>{{ attachment.name }}</span>
                        </a>
                    </div>
                </li>
            </ul>
        </div>
        <loading class="full-page" v-if="loading.length > 0"></loading>
    </div>

    <message-modal v-if="message" :message="message" :loading="savingDetail" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

</div>

</template>

<script>
// Dropzone can't see this.getApiEndPoint for some reason, so we have to do it manually
let developmentEnvironment = (document.location.hostname.indexOf('.test') > -1 || document.location.hostname.indexOf('localhost') > -1)
let hostname = developmentEnvironment ? 'cdsapi.test' : document.location.hostname + '/api'
let api = '//' + hostname + '/api.php'
import { mapGetters, mapActions } from "vuex"
import LabelRequired from '@/components/LabelRequired.vue'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
export default {
    name: 'support-tickets-detail',
    props: [ 'support_ticket_id' ],
    components: {
        'label-required': LabelRequired,
        'vue-dropzone': vue2Dropzone
    },
    data() {
        return {
            loading: [],
            savingDetail: false,
            savingTicket: false,
            messageTimeout: 0,
            messageStatus: '',
            message: '',
            content: '',
            clients: [],
            newSupportTicketDetail: {
                client_id: '',
                topic: '',
                support_ticket_priority_id: '',
                content: '',
                internal_use_only: 0,
                file_reference: []
            },
            newSupportTicketNote: {
                content: '',
                internal_use_only: 1,
                file_reference: []
            },
            filesAdded: 0,
            internalUseOnly: 0,
            supportTicketDetail: {},
            supportTicketThread: [],
            supportTicketNotes: [],
            supportTicketPriorityCodes: [],
            supportTicketStatusCodes: [],
            supportTicketTags: [],
            fileReference: [],
            supportTicketDetailContent: '',
            showDropzone: false,
            supportFilesDropzoneOptions: {
                url: api + '?action=upload_support_files',
				withCredentials: true,
				uploadMultiple: true,
				paramName: 'file_reference',
				maxFilesize: 4,
                createImageThumbnails: false,
                previewsContainer: '.uploaded-files',
                acceptedFiles: 'image/*,application/pdf,text/csv,.csv',
				params: {
					fd_token: this.$getCookie('dashboard_token'),
					source: 'DASHBOARD'
				}
            },
            showDropzoneNote: false,
            adminFilesDropzoneOptions: {
                url: api + '?action=upload_support_files',
				withCredentials: true,
				uploadMultiple: true,
				paramName: 'file_reference',
				maxFilesize: 4,
                createImageThumbnails: false,
                previewsContainer: '.uploaded-admin-files',
                acceptedFiles: 'image/*,application/pdf,text/csv,.csv',
				params: {
					fd_token: this.$getCookie('dashboard_token'),
					source: 'DASHBOARD',
                    support_ticket_id: this.support_ticket_id
				}
            },
            articleLinkId: '',
            searchUPC: '',
            token: ''
        }
    },
    created() {
        // enable token in query string (e.g. from FFL Office)
        const urlParams = new URLSearchParams(window.location.search);
        let urlToken = urlParams.get('fd_token')
        this.token = urlToken || this.$route.query.fd_token
        this.fetchData()
    },
	mounted() {
        if (this.$route.query.content) {
            this.$refs.support_ticket_content.focus()
        }
    },
    watch: {
        support_ticket_id(newVal) {
            this.fetchData()
        }
    },
    computed: {
        ...mapGetters('dashboard_module', [
            'getSupportTickets'
        ]),
        canBeSaved() {
            return (this.newSupportTicketDetail.topic || this.supportTicketDetail.topic) && (this.newSupportTicketDetail.support_ticket_priority_id || this.supportTicketDetail.support_ticket_priority_code) && this.newSupportTicketDetail.content
        },
        previousTicket() {
            var previous = 0
            for (var i = 0; i < this.getSupportTickets.length; i++) {
                if (this.getSupportTickets[i]['support_ticket_id'] == this.support_ticket_id) {
                    break
                }
                previous = this.getSupportTickets[i]['support_ticket_id']
            }
            return previous > 0 ? { path: '/help-center/support-tickets-detail/' + previous, query: this.$route.query } : ''
        },
        nextTicket() {
            var next = 0
            var nextIsNext = false
            for (var i = 0; i < this.getSupportTickets.length; i++) {
                if (nextIsNext) {
                    next = this.getSupportTickets[i]['support_ticket_id']
                    break
                }
                if (this.getSupportTickets[i]['support_ticket_id'] == this.support_ticket_id) {
                    nextIsNext = true
                }
            }
            return next > 0 ? { path: '/help-center/support-tickets-detail/' + next, query: this.$route.query } : ''
        },
        returnPath() {
            var query = {}
            Object.assign(query, this.$route.query)
            var path = '/help-center/support-tickets/' + (query.page || 1)
            if (this.token) {
                path += '?token=' + this.token
            }
            delete query.page
            return { path: path, query: query }
        },
        clientDisplayName() {
            return (this.supportTicketDetail.company_name != '') ? this.supportTicketDetail.company_name : this.supportTicketDetail.first_name + ' ' + this.supportTicketDetail.last_name
        },
        attachFilesHeight() {
            if (this.showDropzone) {
                return 160 + Math.ceil(this.filesAdded / 2) * 35 + 'px'
            } else {
                return 0
            }
        },
        logInAsLink() {
            if (location.hostname.indexOf('.test') > 0) {
                return '//' + location.hostname + ':' + location.port + '/dashboard/login?username=' + this.supportTicketDetail.dealer_user_name
            } else {
                return 'https://' + this.supportTicketDetail.domain_name + '/dashboard/login?username=' + this.supportTicketDetail.dealer_user_name
            }
        }
    },
    methods: {
        ...mapActions('dashboard_module', [
            'fetchSupportTickets'
        ]),
        fetchData() {
            if (this.support_ticket_id == 'new' || this.getAdministratorFlag) {
                if (this.$route.query.topic) {
                    this.newSupportTicketDetail.topic = this.$route.query.topic
                }
                if (this.$route.query.content) {
                    this.newSupportTicketDetail.content = this.$route.query.content + "\n\n"
                }
                if (this.$route.query.tag) {
                    this.newSupportTicketDetail.support_ticket_tag_code = this.$route.query.tag.toUpperCase()
                }
                if (this.supportTicketPriorityCodes.length == 0) {
                    this.loading.push[1]
                    this.apiCall({ destination: 'get_list_support_ticket_priority_codes', data: { fd_token: this.token } }).then(obj => {
                        this.supportTicketPriorityCodes = obj.support_ticket_priority_codes
                        this.loading.pop()
                        if (this.$route.query.priority) {
                            for (let i = 0; i < this.supportTicketPriorityCodes.length; i++) {
                                if (this.supportTicketPriorityCodes[i]['support_ticket_priority_code'] == this.$route.query.priority.toUpperCase()) {
                                    this.newSupportTicketDetail.support_ticket_priority_id = this.supportTicketPriorityCodes[i]['support_ticket_priority_id']
                                    break
                                }
                            }
                        }
                    }).catch(err => {
                        this.loading.pop()
                        console.log(err);
                    })
                }
                if (this.supportTicketStatusCodes.length == 0) {
                    this.loading.push[1]
                    this.apiCall({ destination: 'get_list_support_ticket_status_codes', data: { fd_token: this.token } }).then(obj => {
                        this.supportTicketStatusCodes = obj.support_ticket_status_codes
                        this.loading.pop()
                    }).catch(err => {
                        this.loading.pop()
                        console.log(err);
                    })
                }
                if (this.supportTicketTags.length == 0 && this.getAdministratorFlag) {
                    this.loading.push[1]
                    this.apiCall({ destination: 'get_list_support_ticket_tags', data: { fd_token: this.token } }).then(obj => {
                        this.supportTicketTags = obj.support_ticket_tags
                        this.loading.pop()
                    }).catch(err => {
                        this.loading.pop()
                        console.log(err);
                    })
                }
            }
            if (this.support_ticket_id == 'new' && this.getAdministratorFlag) {
                this.loading.push[1]
                this.apiCall({ destination: 'get_list_clients_full_list' }).then(obj => {
                    this.clients = obj.clients
                    this.loading.pop()
                }).catch(err => {
                    this.loading.pop()
                    console.log(err);
                })
            }
            if (this.support_ticket_id == 'previous' || this.support_ticket_id == 'next') {
                this.loading.push[1]
                var query = {}
                Object.assign(query, this.$route.query)
                this.fetchSupportTickets({ page: query.page, query: query }).then(() => {
                    this.$router.push({ path: '/help-center/support-tickets-detail/' + this.getSupportTickets[query.current].support_ticket_id, query: query })
                }).catch(err => {
                    this.loading.pop()
                    console.log(err);
                })
            } else {
                this.getDetail()
            }
        },
        getDetail() {
            this.loading.push[1]
            let data = { support_ticket_id: this.support_ticket_id }
            if (this.token) {
                data.fd_token = this.token
            }
            this.apiCall({ destination: 'get_item_support_ticket', data: data }).then(obj => {
                this.loading.pop()
                this.supportTicketDetail = obj.support_ticket_detail
                this.supportTicketThread = obj.support_ticket_thread
                this.supportTicketNotes = obj.support_ticket_notes
                this.fileReference = obj.file_reference
            }).catch(err => {
                this.loading.pop()
                console.log(err);
            })
        },
        saveDetail(context) {
            if (this.savingDetail) { return }
            if (context != 'note' && !this.canBeSaved) { return }
            if (context == 'ticket' && !this.newSupportTicketDetail.content) { return }
            if (context == 'note' && !this.newSupportTicketNote.content) { return }
            this.savingDetail = true
            this.message = 'Sending ticket...'
            if (this.support_ticket_id == 'new') {
                var support_ticket_detail = this.$copy(this.newSupportTicketDetail)
                if (this.getAdministratorFlag) {
                    support_ticket_detail.client_id = this.newSupportTicketDetail.client_id
                } else {
                    support_ticket_detail.client_id = this.getClientId
                }
            } else {
                var support_ticket_detail = this.$copy(this.supportTicketDetail)
                if (context == 'ticket') {
                    support_ticket_detail.content = this.newSupportTicketDetail.content
                    support_ticket_detail.internal_use_only = this.newSupportTicketDetail.internal_use_only
                    support_ticket_detail.file_reference = this.newSupportTicketDetail.file_reference
                } else {
                    support_ticket_detail.content = this.newSupportTicketNote.content
                    support_ticket_detail.file_reference = this.newSupportTicketNote.file_reference
                    support_ticket_detail.internal_use_only = 1
                    support_ticket_detail.client_id = this.supportTicketDetail.client_id
                }
            }
            if (this.token) {
                support_ticket_detail.fd_token = this.token
            }
            support_ticket_detail.source = 'DASHBOARD'
            this.apiCall({ destination: 'save_item_support_ticket', data: support_ticket_detail }).then(obj => {
                this.showDropzone = false
                this.savingDetail = false
                this.messageStatus = obj.status
                if (obj.status == 'success') {
                    this.message = 'Ticket sent!'
                    this.messageTimeout = 1000
                    this.newSupportTicketDetail = {
                        content: '',
                        internal_use_only: 0,
                        file_reference: []
                    }
                    this.newSupportTicketNote = {
                        content: '',
                        internal_use_only: 1,
                        file_reference: []
                    }
                    this.showDropzone = false
                    // this.$refs.supportFilesDropzone.removeAllFiles()
                    // this.$refs.adminFilesDropzone.removeAllFiles()
                    this.showDropzoneNote = false
                    if (this.support_ticket_id == 'new') {
                        this.$router.push('/help-center/support-tickets-detail/' + obj.support_ticket_id + (this.token ? '?fd_token=' + this.token : ''))
                    } else if (context == 'ticket') {
                        this.getDetail()
                    } else {
                        this.getDetail()
                    }
                } else {
                    this.message = obj.message
                }
            }).catch(err => {
                this.savingDetail = false
                console.log(err);
            })
        },
        addLinkToDetail() {
            if (!this.articleLinkId) return
            var articleLink = 'https://' + this.supportTicketDetail.domain_name + '/dashboard/help-center/articles/' + this.articleLinkId
            this.newSupportTicketDetail.content += '\n\n' + articleLink
            this.articleLinkId = ''
        },
        // openTicket() {
        //     if (!this.newSupportTicket.content || !this.newSupportTicket.topic || !this.newSupportTicket.support_ticket_priority_id) return
        //     if (this.getAdministratorFlag && !this.newSupportTicket.client_id) return
        //     this.savingDetail = true
        //     this.savingTicket = true
        //     var support_ticket_detail = this.$copy(this.newSupportTicket)
        //     if (this.token) {
        //         support_ticket_detail.fd_token = this.token
        //     }
        //     this.apiCall({ destination: 'save_item_support_ticket', data: support_ticket_detail }).then(obj => {
        //         this.savingDetail = false
        //         this.savingTicket = false
        //         if (obj.status == 'success') {
        //             this.$router.push('/help-center/support-tickets-detail/' + obj.support_ticket_id)
        //         }
        //     }).catch(err => {
        //         this.savingTicket = false
        //         this.savingDetail = false
        //         console.log(err);
        //     })
        // },
        updateTicket() {
            if (!this.getAdministratorFlag) return
            this.savingDetail = true
            this.message= 'Updating ticket...'
            var support_ticket_detail = this.$copy(this.supportTicketDetail)
            var supportTicketStatus = this.supportTicketStatusCodes.find(element => element.support_ticket_status_id == support_ticket_detail.support_ticket_status_id)
            support_ticket_detail.support_ticket_status_code = supportTicketStatus.support_ticket_status_code
            var supportTicketPriority = this.supportTicketPriorityCodes.find(element => element.support_ticket_priority_id == support_ticket_detail.support_ticket_priority_id)
            support_ticket_detail.support_ticket_priority_code = supportTicketPriority.support_ticket_priority_code
            var supportTicketTag = this.supportTicketTags.find(element => element.support_ticket_tag_id == support_ticket_detail.support_ticket_tag_id)
            if (supportTicketTag) {
                support_ticket_detail.support_ticket_tag_code = supportTicketTag.support_ticket_tag_code
            }
            this.apiCall({ destination: 'save_item_support_ticket', data: support_ticket_detail }).then(obj => {
                this.messaageStatus = obj.status
                this.savingDetail = false
                if (obj.status == 'success') {
                    this.message = 'Ticket updated!'
                    this.messageTimeout = 1000
                    this.fetchData()
                } else {
                    this.message = obj.message
                }
            }).catch(err => {
                this.savingDetail = false
                console.log(err);
            })
        },
        closeSupportTicket() {
            this.message = 'Closing ticket...'
            this.savingTicket = true
            this.apiCall({ destination: 'close_item_support_ticket', data: { support_ticket_id: this.supportTicketDetail.support_ticket_id }}).then(obj => {
                this.savingTicket = false
                this.messageStatus = obj.status
                if (obj.status == 'success') {
                    this.message = 'Ticket closed!'
                    this.messageTimeout = 1000
                    this.fetchData()
                } else {
                    this.message = obj.message
                }
            }).catch(err => {
                this.savingTicket = false
                console.log(err);
            })
        },
        reopenSupportTicket() {
            this.savingTicket = true
            this.message = 'Reopening ticket...'
            this.apiCall({ destination: 'reopen_item_support_ticket', data: { support_ticket_id: this.supportTicketDetail.support_ticket_id }}).then(obj => {
                this.savingTicket = false
                this.message = obj.message
                this.messageStatus = obj.status
                if (obj.status == 'success') {
                    this.message = 'Ticket reopened...'
                    this.messageTimeout = 1000
                    this.fetchData()
                } else {
                    this.message = obj.message
                }
            }).catch(err => {
                this.savingTicket = false
                console.log(err);
            })
        },
        supportFilesUploadSuccess(file, response) {
            var obj = JSON.parse(response)
            obj.file_reference.forEach((file, i) => {
                this.newSupportTicketDetail.file_reference.push(file)
            });
            this.savingDetail = false
        },
        supportFilesUploadError(file, message, xhr) {
			console.log('supportFilesUploadError')
			console.log(file)
			console.log(message)
			console.log(xhr)
		},
        supportFilesFileAdded(file) {
            this.savingDetail = true
            this.filesAdded++
        },
        supportFilesRemovedFile(file, error, xhr) {
            // console.log(file, error, xhr);
        },
        adminFilesUploadSuccess(file, response) {
            var obj = JSON.parse(response)
            obj.file_reference.forEach((file, i) => {
                this.newSupportTicketNote.file_reference.push(file)
            });
            this.savingDetail = false
        },
        adminFilesUploadError(file, message, xhr) {
			console.log('adminFilesUploadError')
			console.log(file)
			console.log(message)
			console.log(xhr)
		},
        adminFilesFileAdded(file) {
            // this.savingDetail = true
            // this.filesAdded++
        },
        adminFilesRemovedFile(file, error, xhr) {
            // console.log(file, error, xhr);
        },
        searchForUPC() {
            if (this.searchUPC) {
                //window.open('/dashboard/legacy/productmaintenance.php?search_term=' + this.searchUPC, '_blank');
                window.open('/dashboard/inventory/manage-products/distributor?search_term=' + this.searchUPC, '_blank');
            }
        }
    }
}
</script>

<style lang="scss">
label.checkbox span {
    margin: 0;
}
.add-link {
    input {
        margin: 0;
    }
}
</style>
